import { FirearmAssignablePersonResolverBase } from './firearm-assignable-person.resolver.base';
import { FirearmAssignablePersonService } from './firearm-assignable-person.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class FirearmAssignablePersonResolver extends FirearmAssignablePersonResolverBase {

  constructor(protected service: FirearmAssignablePersonService) {
    super(service);
  }
}



